import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'

const ListItem = ({entity}) => {
  const keyword = get(entity, 'key', null)
  const char = get(entity, 'char', null)

  return (
    <div>
      <span className="is-family-monospace">{keyword}</span> <span>{char}</span>
    </div>
  )
}

ListItem.propTypes = {
  entity: PropTypes.any,
}

export default ListItem
